//关系
// 父-father 母-mother 哥-elder_brother  弟-brother 配偶-spouse
// 姐-elder_sister 妹-younger_sister  儿-son  女-daughter
const type = function (value, args) {
  switch (value) {
    case "father":
      return "父亲";
      break;
    case "mother":
      return "母亲";
      break;
    case "elder_brother":
      return "哥哥";
      break;
    case "brother":
      return "弟弟";
      break;
    case "spouse":
      return "配偶";
      break;
    case "elder_sister":
      return "姐姐";
      break;
    case "younger_sister":
      return "妹妹";
      break;
    case "son":
      return "儿子";
      break;
    case "daughter":
      return "女儿";
      break;
  }
};
const randomId = function () {
  return (Math.random() + new Date().getTime()).toString(32).slice(0, 8);
};
const allType = [
  {
    typeName: "parentNode",
    typeData: [
      {
        label: "父亲",
        value: "father",
      },
      {
        label: "母亲",
        value: "mother",
      },
    ],
  },
  {
    typeName: "sameNode",
    typeData: [
      {
        label: "添加同级节点",
        value: "elder_brother",
      },
    ],
  },
  {
    typeName: "childrenNode",
    typeData: [
      {
        label: "添加子节点",
        value: "son",
      },
    ],
  },
  {
    typeName: "spouseNode",
    typeData: [
      {
        label: "配偶",
        value: "spouse",
      },
    ],
  },
];
const classType = function (value, args) {
  let men = ["father", "son", "elder_brother", "younger_brother"];
  let women = ["mother", "elder_sister", "younger_sister", "daughter"];
  //为配偶时
  if (value === "spouse") {
    return "iconfont icon-aixin";
  }
  // 为男性时
  if (men.includes(value)) {
    return "item_icon menIcon";
  }
  // 为女性时
  if (women.includes(value)) {
    return "item_icon womenIcon";
  }
};

const rules = {
  //姓名
  name: [
    { required: true, message: "请输入节点名称", trigger: "blur" },
  ],
  namenum:[ 
    { 
      required: true, 
      message: "请输入节点数量", 
      trigger: "blur" 
    },
    {
      pattern: /^[0-9]+$/,
      message: "请输入有效的节点数量",
      trigger: "blur"
    }
  ],
  // 性别
  sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
  // 关系类型
  type: [{ required: true, message: "请选择节点关系", trigger: "blur" }],
  // 配偶选择
  pitchSpouseId: [
    { required: true, message: "请选择所属配偶", trigger: "blur" },
  ],
  // 分支名称
  label: [
    { required: true, message: "请输入分支名称", trigger: "blur" },  
  ],
  treeName: [
    { required: true, message: "请输入分支名称", trigger: "blur" },
  ],
};
export { type, allType, classType, rules, randomId };
